<!-- <app-langding-page-nav-bar></app-langding-page-nav-bar> -->

<div class="container" style="margin-top: 5rem;">
  <div class="search-page-layout">
    <div class="search-menu">
      <div class="hpanel stickkyy-template">
        <div class="panel-body border-radius-top-left-right-6">
          <label for=""> Search Result for</label>
          <div class="input-group">
            <input class="form-control" type="text" placeholder="Search" value="{{searchText}}">
          </div>
        </div>
      </div>
      <div class="fixed-search-menu">
        <app-search-menu (menuSelected)="navigation($event)" ></app-search-menu>
      </div>
    </div>
    <div class="search-feed">
      <app-all-user-list *ngIf="menuData == 'ALL'"></app-all-user-list>
      <app-people *ngIf="menuData == 'USER'"></app-people>
      <app-business-user *ngIf="menuData == 'BUSINESS_PAGE'"></app-business-user>
      <!-- <app-bussiness-post *ngIf="menuData == 'post'"></app-bussiness-post> -->
      <app-post *ngIf="menuData == 'post'"></app-post>
      <!-- <app-communities *ngIf="menuData == 'COMMUNITY_PAGE'" ></app-communities> -->
      <app-searchjob *ngIf="menuData == 'JOBSSEARCH'"></app-searchjob>
      <app-searchcandidate *ngIf="menuData == 'CANDIDATESEARCH'"></app-searchcandidate>
      <!-- <app-seachtags      *ngIf="menuData == 'TAG'"></app-seachtags> -->
    </div>
  </div>
  <!-- <div class="row">
                <div class="col-lg-12">
                    <div class="hpanel gs-cardgs-card">
                        <div class="panel-body gs-card-body" style="height: 8rem;">
                          <div class="row" style="margin-top: 1rem;">
                            <div class="col-md-3">
                              <div style="margin-top: 5px;">
                                <p>People </p>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="input-group">
                                <input class="form-control" type="text" [(ngModel)] ="term" #filterData>
                                <div class="input-group-btn">
                                    <button class="btn btn-default"><ng-icon name="tablerSearch"></ng-icon></button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <button class="btn btn-outline-primary">Filter</button>
                              <button class="btn btn-primary" style="margin-left: 10px;">Advance Search</button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div> -->
  <!-- <div class="row">
    <div class="col-md-12 ">
      <div class="hpanel gs-cardfilter-item">
        <div class="">


        </div>
      </div>
    </div>
  </div> -->
</div>
